var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"step_item"},[_c('Table',{attrs:{"list":_vm.list,"title":_vm.title,"play":_vm.play}},[_c('div',{staticClass:"more",attrs:{"slot":"foot"},slot:"foot"},[_c('Page',{attrs:{"all":_vm.total,"size":_vm.pageSize,"isBtn":false},model:{value:(_vm.pageNum),callback:function ($$v) {_vm.pageNum=$$v},expression:"pageNum"}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }